"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _SiteLayout = require("layouts/SiteLayout");

var _react = babelHelpers.interopRequireWildcard(require("react"));

var HtmlPage =
/*#__PURE__*/
function (_Component) {
  babelHelpers.inherits(HtmlPage, _Component);

  function HtmlPage() {
    babelHelpers.classCallCheck(this, HtmlPage);
    return babelHelpers.possibleConstructorReturn(this, babelHelpers.getPrototypeOf(HtmlPage).apply(this, arguments));
  }

  babelHelpers.createClass(HtmlPage, [{
    key: "render",
    value: function render() {
      var _HtmlPage$extractInli = HtmlPage.extractInlineScripts(this.props.content.content),
          content = _HtmlPage$extractInli.content,
          scripts = _HtmlPage$extractInli.scripts;

      return _react.default.createElement(_SiteLayout.PageContentContainer, {
        content: content,
        scripts: scripts.concat(this.props.content.scripts)
      });
    }
  }], [{
    key: "extractInlineScripts",
    value: function extractInlineScripts(content) {
      var scripts = [],
          start;

      while ((start = content.indexOf('<script')) != -1) {
        var endScriptOpen = content.indexOf('>', start) + 1;
        var startScriptClose = content.indexOf('</script>', endScriptOpen);
        scripts.push(content.substring(endScriptOpen, startScriptClose));
        content = content.substring(0, start) + content.substring(startScriptClose + '</script>'.length);
      }

      scripts = scripts.map(function (script) {
        return {
          _global: true,
          fn: "function() { ".concat(script, "; }")
        };
      });
      console.log(scripts);
      return {
        scripts: scripts,
        content: content
      };
    }
  }]);
  return HtmlPage;
}(_react.Component);

exports.default = HtmlPage;